var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66893 25.2346L5.64354 28.6185C5.49777 28.741 5.32004 28.8194 5.13126 28.8444C4.94247 28.8694 4.75048 28.8399 4.57785 28.7595C4.40523 28.6791 4.25915 28.5511 4.15679 28.3905C4.05444 28.2299 4.00006 28.0435 4.00006 27.853V8.00006C4.00006 7.73484 4.10542 7.48049 4.29295 7.29295C4.48049 7.10542 4.73484 7.00006 5.00006 7.00006H27.0001C27.2653 7.00006 27.5196 7.10542 27.7072 7.29295C27.8947 7.48049 28.0001 7.73484 28.0001 8.00006V24.0001C28.0001 24.2653 27.8947 24.5196 27.7072 24.7072C27.5196 24.8947 27.2653 25.0001 27.0001 25.0001H10.3124C10.077 25.0001 9.84913 25.0831 9.66893 25.2346Z",
    fill: "none",
    stroke: "#009fd1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueChatIcon);
export default __webpack_public_path__ + "static/media/blueChatIcon.10573cf022235488531230af840c72cd.svg";
export { ForwardRef as ReactComponent };